import { ReactionType } from './types';

export const DefaultShortcode = ':thumbsup:';

export const ShortcodeMap: Record<string, ReactionType> = {
	'star-struck': ReactionType.Amaze,
	clap: ReactionType.Celebrate,
	heart: ReactionType.Love,
	laughing: ReactionType.Laugh,
	thumbsup: ReactionType.Like,
};

export const UnicodeMap: Record<string, ReactionType> = {
	'\u{1F44D}': ReactionType.Like, // 👍
	'\u{2764}\u{FE0F}': ReactionType.Love, // ❤️ (with variation selector)
	'\u{2764}': ReactionType.Love, // ❤ (without variation selector)
	'\u{1F973}': ReactionType.Celebrate, // 🥳
	'\u{1F929}': ReactionType.Amaze, // 🤩
	'\u{1F606}': ReactionType.Laugh, // 😆
};

export const TypeToUnicodeMap: Record<ReactionType, string> = {
	[ReactionType.Like]: '\u{1F44D}',
	[ReactionType.Love]: '\u{2764}\u{FE0F}',
	[ReactionType.Celebrate]: '\u{1F973}',
	[ReactionType.Amaze]: '\u{1F929}',
	[ReactionType.Laugh]: '\u{1F606}',
};
